import { render, staticRenderFns } from "./addBanner.vue?vue&type=template&id=6f27cfd9"
import script from "./addBanner.vue?vue&type=script&lang=js"
export * from "./addBanner.vue?vue&type=script&lang=js"
import style0 from "./addBanner.vue?vue&type=style&index=0&id=6f27cfd9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports